import { SpyneTrait } from 'spyne';
import { DeckContainer } from 'components/deck/deck-container.js';

export class PageDeckTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'pageDeck$';
    super(context, traitPrefix);
  }

  static pageDeck$onRendered() {
    this.appendView(new DeckContainer(), '.page-body');
  }
}
